// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,  
  apiUrl: 'https://api-testing.i-host.gr/iManage',
  auditTrailUrl: 'https://audit-trail-test.i-host.gr',
  supportApiUrl: 'https://support-api-test.i-host.gr',
  showTags: true,
  requestOverlayThreashold: 1000,
  serviceStopWarningDaysBefore: 30,
  doubleBookingTimeoutMs:3000,
  adsDataUrl: 'https://files.i-host.gr/data/ads-test.json',
  webServerUrl: 'https://www-test.i-host.gr',
  ordersApiUrl: 'https://menu-api-test.i-host.gr',
  reportsApiUrl: "https://reporting-test.i-host.gr/api",
  marketingToolUrl: "https://marketing.test.i-host.gr",
  broadcastUrl: "https://storage.googleapis.com/ihost-messges/broadcast-pocket-test.json",
  broadcastMessageRefreshIntervalMins: 1,
  version: "2026-07-21 TEST"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
